import React, { useState } from "react";
import styled from "@emotion/styled";
import QuestionEngine from "./Questions/QuestionEngine";
import UpTastingLogo from "../../../../assets/images/hcb_logo.png";
import Background1 from "../../../../assets/images/buser1.jpg";
import Background2 from "../../../../assets/images/buser1_1.jpg";


const ScreenComponent = ({ config, screen, actions, getLangIcon, boolEmail }) => {
    const isMobile = config?.mediaQueries?.maxWidth426;

    const Wrapper = {
        height: config?.mediaQueries?.maxWidth426 ? "93%" : "100%",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        position: "relative",
        backgroundImage: `url(${config.background ? "" : boolEmail ? Background2 : Background1})`,
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
    };

    const ScreenContainer = {
        display: "flex",
        width: isMobile ? "95%" : "70%",
        height: isMobile ? "calc(90% - 3vh)" : "calc(93% - 5vh)",
        margin: isMobile ? "1vh auto" : "3vh auto",
        flexDirection: isMobile ? "column" : "row",
        overflowX: "hidden",
        overflowY: "auto",
    }

    const TopBar = styled.div`
        background-image: linear-gradient(white 90%, transparent);
        width: 100%;
        height: 7%;
        margin-bottom: 2vh;
        flex-direction: column;

        @media (max-width: 426px) {
            height: 10%;
        }
    `;

    const LogoWrapper = styled.div`
        position: absolute;
        width: 60%;
        height: 15%;
        background-image: linear-gradient(-15deg, transparent 70%, white 71%);
        color: white;

        @media (max-width: 426px) {
            height: 30%;
            width: 75%;
        }
    `;

    const Logo = styled.img`
        max-width: 7vw;
        max-height: 7vh;
        margin: 2vh;

        @media (max-width: 426px) {
            margin: 1.5vh;
            max-width: 15vw;
            max-height: 13vh;
        }
    `;

    const Languages = styled.div`
        position: absolute;
        width: fit-content;
        height: calc(7% - 1vh);
        display: flex;
        right: 2vh;
        align-items: center;

        @media (max-width: 426px) {
            height: calc(9% - 1vh);
        }
    `;

    const Lang = styled.img`
        width: 3.5vh;
        margin: 0 1.5vh;
        cursor: pointer;
    `;

    const Lang2 = styled.div`
        width: 2vw;
        font-size: 3vh;
        margin: 0 1.5vh;
        cursor: pointer;
    `;

    return (
        <div style={Wrapper}>
            <TopBar>
                <LogoWrapper>
                    <Logo src={config.logo || UpTastingLogo} />
                </LogoWrapper>
                <Languages>
                    {(config.alternativeLanguages || []).map((lang, i) => {
                        if (config.languageDisplayMode === "TEXT") {
                            return (<Lang2 onClick={(e) => actions.updateLang(lang)}>
                                {lang === "ca_ES" ? "CA" : lang.split("_")[1]}
                            </Lang2>);
                        }
                        else {
                            return (<Lang src={getLangIcon(lang)} onClick={(e) => actions.updateLang(lang)} />);
                        }
                    })}
                </Languages>
            </TopBar>

            <div style={ScreenContainer}>
                {(screen?.questions || []).map((question, i) => {
                    return (<QuestionEngine key={"question" + i} config={config} index={i} question={question} actions={actions} screen={screen} />);
                })}
            </div>

        </div>
    );
};

export default ScreenComponent;
